import React from 'react';
import { ModalBody, ModalHeader } from 'reactstrap';
import Rodal from '../../../../components/Rodal/Rodal';
import { LoiSubmissionPackage } from '../../../Admin/BuyerMarketplace/OpportunityDetails/LoiSubmissionPackage/LoiSubmissionPackage';

interface LoiSubmissionInformationSupplementPopupProps {
    loiFormId: string;
    engagementId: number;
    isProcessCompleted: boolean;
    onClose: () => void;
}

const LoiSubmissionInformationSupplementPopup = (
    props: LoiSubmissionInformationSupplementPopupProps
) => {
    return (
        <Rodal
            visible={true}
            onClose={props.onClose}
            animation="slideUp"
            showMask={true}
            width={1000}
            showCloseButton={true}
            customStyles={{ height: 'auto' }}>
            <ModalHeader>LOI Submission Information Supplement</ModalHeader>
            <ModalBody style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                <LoiSubmissionPackage
                    loiFormId={props.loiFormId}
                    isReadonly={true}
                    engagementId={props.engagementId}
                    canSubmit={false}
                    isLoiTabTermsOnly={true}
                    showOwnerObligationsTab={true}
                    isOwnerObligationsTabOnly={!props.isProcessCompleted}
                />
            </ModalBody>
        </Rodal>
    );
};

export default LoiSubmissionInformationSupplementPopup;
